/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// component
import PartnerLogo from 'material/embeds/content/shared/logo/partner/partner';



/* ========== ~~~~~~~~~~ EMBED : PARTNER LOGO : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }) => ({
    selectedEmbedStatus: embedsState.embedManagementState.selectedEmbedStatus
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps
)(PartnerLogo);
